import React from 'react';
import { Link } from '@one-thd/sui-atomic-components';
import { bool } from 'prop-types';

import { signIn } from '../../utils';

export const SignInLink = ({ isOnListSummary }) => {
  return (
    <div>
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <Link
        component="button"
        onClick={signIn}
        style={{
          color: '#3E7697',
          fontSize: isOnListSummary ? '10px' : '',
          textAlign: isOnListSummary ? 'right' : ''
        }}
      >
        Sign in for The Home Depot price
      </Link>
    </div>
  );
};

SignInLink.propTypes = {
  isOnListSummary: bool
};

SignInLink.defaultProps = {
  isOnListSummary: false
};

SignInLink.displayName = 'SignInLink';